<template>
    <SOSlotModal
    modal-title="Ubah Jenis Item"
    :modal-id="id"
    :no-padding="true"
    @close="close()"
    >   
        <template v-slot:modal-body>
            <div class="p-l-24 p-r-24 p-d-12">
                <div class="">
                    <SOInputRegular
                        class="p-t-2"
                        :title="'Nama Item'"
                        :placeholder="'Nama Item'"
                        :validation="'alphanumeric'"
                        v-model= "data.nama"
                        :required="true"
                    />
                    <ErrorMessage
                    class="error"
                    label="Nama Item"
                    :validation="$v.data.nama"
                    ref="errmsg_nama_item"
                    />
                </div>
            </div>
        </template>
        <template v-slot:modal-footer>
            <div class="p-r-24 p-l-24">
                <p class="mb-0 f-14 f-c-midgrey p-d-12">
                    Item akan otomatis terpilih saat kasir membuat transaksi baru.
                </p>
                <div class="p-d-24">
                    <SOButton
                        :text="'Simpan'"
                        :outline="true"
                        :full="true"
                        :id="'save-edit-item'"
                        :loading="isLoading"
                        :disable="isLoading"
                        @action="updateItem()"
                    />
                </div>
            </div>
        </template>
    </SOSlotModal>
</template>
<script>
import {mapGetters} from "vuex";
import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import ErrorMessage from "@/component-items/ErrorMessage";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputRegular from '@/so-components/global/input/SOInputRegular';
import SOButton from "@/so-components/global/ui/SOButton";
import { maxLength, minLength, required, alphaNum } from "vuelidate/lib/validators";

export default {
    name: "DetailitemModalEdit",
    components: {
        SOSlotModal,
        ErrorMessage,
        SOInputRegular,
        SOButton
    },
    data() {
        return {
            id: "modal-edit",
            data: {},
            namaItem: "",
            isLoading: false,
        }
    },
    computed: {
        ...mapGetters("daftarItemModule", {
            listDataItem: "getListDataItem",
        }),
    },
    validations: {
        data: {
            nama: {
                required,
                minLength: minLength(2),
                maxLength: maxLength(45),
                alphaNum
            }
        }
    },
    methods: {
        errorValidate(){
            let { 
                nama
            } = this.$v.data;
            nama.$touch();
            return (nama.$invalid)
        },
        open(item) {
            this.data = item
            $("#" + this.id).modal("show");
        },
        close() {
            $("#" + this.id).modal("hide");
            this.$emit("finishedEdit")
            setTimeout(() => {
                this.$emit("close");
            }, 500);
        },
        async updateItem() {
            const form = new FormData
            form.append("iditem", this.data.iditem);
            form.append("nama", this.data.nama);
            this.isLoading = true
            try {
                const res = await conn.post(this.$baseurl + ('masterData/item/update_item'), form, conn.contentType.form)
                console.log(res);
                if(res.status){
                    this.$emit("finishedEdit")
                    $("#" + this.id).modal("hide");
                    this.$toast.success('Data berhasil diubah')
                }else{
                    this.isLoading = false
                    // console.log(res.data)
                    this.$toast.error(res)
                }
            } catch (error) {
                console.log(error)
                this.$toast.error(error);
            }
            this.isLoading = false
        }
    }
}
</script>